module.exports = __webpack_public_path__ + "static/img/settle-img2.99b55172.png";